const ZB_API_KEY = 'a63ffc5ab29b423ea9b13db077242479';

export const validateAndSuppress = async (email, supabase) => {
  try {
    const response = await fetch(
      `https://api.zerobounce.net/v2/validate?api_key=${ZB_API_KEY}&email=${encodeURIComponent(email)}`
    );
    const data = await response.json();

    // 1. Logic: invalid, abuse, and spamtrap get banned immediately
    const isGarbage = data.status === 'invalid' || data.status === 'abuse' || data.status === 'spamtrap';

    if (isGarbage) {
      console.warn(`Shield Triggered: ${email} is ${data.status}. Adding to suppression list.`);
      
      // Update your Suppression Table
      await supabase
        .from('email_suppression_list')
        .upsert(
          { 
            email: email.toLowerCase(), 
            reason: `ZeroBounce: ${data.status}` 
          }, 
          { onConflict: 'email' }
        );

      return { isValid: false, status: data.status };
    }

    // 2. If valid or catch-all, let it through
    if (data.status === 'valid' || data.status === 'catch-all') {
      return { isValid: true, status: data.status };
    }

    // 3. Fallback for unknowns/errors
    return { isValid: true, status: 'bypass' };

  } catch (error) {
    console.error("ZeroBounce Check Failed. Bypassing...");
    return { isValid: true, status: 'api_error' };
  }
};